export const getHasOutage = (state) => state.support.hasOutage

export default getHasOutage
